import Vue from "vue";
import Vuex from "vuex";
import Modifiers from "@/classes/Modifiers";
import hourPrice from "@/services/hourPrice";

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    monthIncome: 50000,
    result: {},
    modifiers: new Modifiers()
  },
  mutations: {
    // result (state) {
    //   state.result = hourPrice.calculate(state.monthIncome, state.modifiers);
    // },
    modifiers(state, modifiers) {
      state.modifiers = {...state.modifiers, ...modifiers}
    },
    monthIncome(state, monthIncome: number) {
      state.monthIncome = monthIncome;
    }
  },
  getters: {
    result (state) {
      return hourPrice.calculate(state.monthIncome, state.modifiers);
    }
  },
  actions: {
    changeMonthIncome (context, monthIncome: number) {
      context.commit('monthIncome', monthIncome);
    },

    changeModifiers (context, modifiers: HourPrice.Modifiers) {
      context.commit('modifiers', modifiers);
    },

    calculate (context) {
      context.commit('result');
    }
  }
});
